import {FC, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import { defaultProfileImage } from '../../../utils/constants'

interface MemberImageProps {
  profilePicture?: string
  picFooter?: string
  loading: boolean
}

export const MemberImage: FC<MemberImageProps> = ({profilePicture, picFooter, loading}) => {
  const [profileImage, setProfileImage] = useState<string>(toAbsoluteUrl(''))
  const [isImageLoading, setIsImageLoading] = useState<boolean>(true)

  const handleImageLoad = () => {
    setIsImageLoading(false)
  }

  const handleImageError = (e) => {
    setIsImageLoading(false)
    e.currentTarget.src = defaultProfileImage;
  }

  useEffect(() => {
    if (profilePicture && typeof profilePicture === 'string' && profilePicture.trim() !== '') {
      setIsImageLoading(true)
      setProfileImage(`${profilePicture}?t=${Date.now()}`)
    }
  }, [profilePicture])
  return (
    <div className='biography__right'>
      <div className='bg-block'></div>
      {isImageLoading && <div className='nb-pm-image__skeleton' />}
      <div className="quote-profile">
        <img
          className={`${isImageLoading ? 'nb-pm-image__photo--hidden' : 'nb-pm-image__photo'}`}
          src={profileImage}
          alt='profile'
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
        <div className='quote'>
          <span>{picFooter}</span>
        </div>
      </div>
    </div>
  )
}
